import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQItemm from './FAQItemm';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punenearbysightseeingspot() {



    const cardData =
    {
        keyword: 'Pune Nearby Sightseeing Spot Morachi Chincholi',
        heading: 'Anand Krushi Paryatan Kendra: Pune Nearby Sightseeing Spot Morachi Chincholi',
        headingDescription: 'Craving a serene sightseeing spot near Pune in Morachi Chincholi? Discover Anand Krushi Paryatan Kendra, a tranquil 40-acre agri-tourism oasis just 55 km from the city. This eco-friendly retreat blends lush farm landscapes with engaging rural experiences, making it a top Pune nearby sightseeing spot Morachi Chincholi. Perfect for families, educational outings, and corporate groups, the center offers an action-packed yet relaxing day: bullock cart and tractor rides, horse riding, boating, swimming, and refreshing rain-dance sessions. Traditional village games and cultural highlights like puppet and magic shows offer authentic rural charm.',

        top: 'Top Activities at Anand Krushi Paryatan Kendra:',

topPlaces: [
  {
    "title": "Morachi Chincholi – Peacock Village",
    "description": "A serene agro-tourism village 55 km from Pune, famous for its natural peacock habitat. Visitors can enjoy birdwatching, bullock cart rides, rural games, and delicious Maharashtrian food at local farms."
  },
  {
    "title": "Anand Krushi Paryatan Kendra",
    "description": "A top agro-tourism center inside Morachi Chincholi offering tractor safaris, organic farming experiences, pottery workshops, splash pools, and authentic rural meals. Great for family trips and school groups."
  },
  {
    "title": "Ranjangaon Mahaganpati Temple",
    "description": "One of the Ashtavinayak Ganpati temples located about 25 km from Morachi Chincholi. A peaceful spiritual spot with rich heritage and traditional architecture."
  },
  {
    "title": "Tulapur Sangam Ghat",
    "description": "A historical and spiritual riverside site where Sambhaji Maharaj was martyred. Located on the confluence of Bhima and Indrayani rivers, it's a quiet and culturally rich destination."
  },
  {
    "title": "Shivneri Fort",
    "description": "Birthplace of Chhatrapati Shivaji Maharaj, approx. 60 km from Morachi Chincholi. Offers scenic trekking paths, water cisterns, and stunning hilltop views of the surrounding region."
  },
  {
    "title": "Bhuleshwar Temple",
    "description": "An ancient Shiva temple around 50 km from the region. Known for its rare architectural blend of Hindu and Islamic styles, carved stone idols, and panoramic hilltop setting."
  },
  {
    "title": "Ghod River Backwaters",
    "description": "A lesser-known but peaceful picnic spot close to Morachi Chincholi. Ideal for bird watching, photography, and quiet time by the water — especially beautiful during monsoon."
  },
  {
    "title": "Chintamani Ganpati Temple, Theur",
    "description": "Another sacred Ashtavinayak temple around 65 km from Morachi Chincholi, known for its spiritual significance and tranquil village surroundings."
  },
  {
    "title": "Rural Hurda Parties (Seasonal)",
    "description": "Attend a traditional hurda party (Nov–Feb) at nearby farms. Roasted green jowar with chutneys and jaggery, served with folk music and open-air fun."
  },
  {
    "title": "Pabal Science Park (Vigyan Ashram)",
    "description": "Located near Morachi Chincholi, this educational center offers insights into rural innovation, technology, and sustainable farming. Great for school tours and curious minds."
  }
],




"services": [
  {
    "name": "Sightseeing Spots Near Morachi Chincholi",
    "description": "Anand Krushi Paryatan Kendra is surrounded by a rich variety of sightseeing destinations near Morachi Chincholi. From cultural hubs and nature parks to heritage sites and vibrant local markets, this area is ideal for day travelers and nature enthusiasts."
  },
  {
    "name": "Nature and Garden Tours",
    "description": "Stroll through lush mango orchards, vegetable gardens, and native flora trails at Anand Krushi Paryatan Kendra. The farm also serves as a base to explore nearby garden spots and rural green zones teeming with life and tranquility."
  },
  {
    "name": "Historical Sightseeing Near Pune",
    "description": "Just a short drive away, discover ancient forts, Maratha-era temples, and local historical monuments. At the farm itself, guests enjoy glimpses into traditional rural architecture and farming history."
  },
  {
    "name": "Cultural Attraction Visits",
    "description": "Enjoy traditional folk music, rural theatre, and local art forms. Anand Krushi Paryatan Kendra regularly hosts cultural events that allow visitors to engage with local customs, crafts, and culinary traditions."
  },
  {
    "name": "Wildlife Parks and Reserves",
    "description": "Located within a peacock sanctuary zone, the farm is perfect for spotting exotic birds and native animals. Visitors can also plan extended visits to nearby wildlife reserves for a deeper eco experience."
  },
  {
    "name": "Adventure Sightseeing Places",
    "description": "For thrill-seekers, Anand Krushi Paryatan Kendra offers adventure elements like rope bridges, rural obstacle courses, and guided nature treks—blending sightseeing with outdoor activity."
  },
  {
    "name": "Scenic Viewpoints and Hills",
    "description": "Catch sunrise or sunset from elevated areas around the farm. Scenic ridges and countryside viewpoints provide breathtaking backdrops, ideal for quiet reflection or photography."
  },
  {
    "name": "Religious Sightseeing Spots",
    "description": "Combine your agro-tourism visit with a trip to nearby spiritual landmarks, such as local temples and shrines that reflect regional faith and traditional architecture."
  },
  {
    "name": "Family-Friendly Sightseeing Tours",
    "description": "Anand Krushi Paryatan Kendra is designed for families, offering safe and interactive experiences like animal feeding, bullock cart rides, and kid-friendly play zones."
  },
  {
    "name": "Local Markets and Fairs",
    "description": "Explore local bazaars for farm produce, spices, rural handicrafts, and snacks. The farm also has a mini-market featuring organic items and handmade products created by local villagers."
  },
  {
    "name": "Waterfall Visits",
    "description": "During monsoon season, guests can take a short trip to nearby waterfalls and seasonal streams, pairing the experience with a delicious rural meal and rest at the farm."
  },
  {
    "name": "Heritage Tours",
    "description": "Get a taste of local heritage through immersive farm stays, food experiences, and exposure to old-world farming tools, traditions, and village life at Anand Krushi Paryatan Kendra."
  },
  {
    "name": "Eco-Tourism Sightseeing",
    "description": "The farm is a working model of eco-tourism—using organic farming, water conservation, and solar practices. Guests can tour these setups and learn about sustainable rural living."
  },
  {
    "name": "Picnic-Friendly Sightseeing Spots",
    "description": "Enjoy shaded picnic zones, farm-fresh meals, and relaxed outdoor seating areas that make Anand Krushi Paryatan Kendra one of the top picnic sightseeing destinations in the area."
  },
  {
    "name": "Photography Sightseeing Locations",
    "description": "Capture the charm of rural life—from sunrise over the fields to colorful traditional scenes and birdlife. Photography enthusiasts will find countless subjects to frame throughout the farm."
  }
],
"tableData": [
  ["Sightseeing Spots Near Morachi Chincholi", "- Nature and Garden Tours"],
  ["Historical Sightseeing Near Pune", "- Cultural Attraction Visits"],
  ["Wildlife Parks and Reserves", "- Adventure Sightseeing Places"],
  ["Scenic Viewpoints and Hills", "- Religious Sightseeing Spots"],
  ["Family-Friendly Sightseeing Tours", "- Local Markets and Fairs"],
  ["Waterfall Visits", "- Heritage Tours"],
  ["Eco-Tourism Sightseeing", "- Picnic-Friendly Sightseeing Spots"],
  ["Photography Sightseeing Locations", "- "]
],



"whychoose": [
  {
    "WhyChooseheading": "Famous Peacock Village - Morachi Chincholi",
    "WhyChoosedescription": "Known as the 'Peacock Village,' Morachi Chincholi boasts thousands of peacocks freely roaming the ancient tamarind groves. It’s a unique spot near Pune where visitors can witness peacock dances and calls in their natural habitat."
  },
  {
    "WhyChooseheading": "Anand Krushi Paryatan Kendra - Agro Tourism Hub",
    "WhyChoosedescription": "Located within Morachi Chincholi, this agritourism center offers an immersive rural experience with bullock cart rides, farm visits, tractor tours, and authentic Maharashtrian farm-to-table meals."
  },
  {
    "WhyChooseheading": "Nighoj Potholes Geological Marvel",
    "WhyChoosedescription": "Just 25 km from Morachi Chincholi, Nighoj features extraordinary natural potholes carved by the Kukadi River—a perfect destination for nature lovers and photographers."
  },
  {
    "WhyChooseheading": "Ranjangaon Mahaganpati Temple",
    "WhyChoosedescription": "One of the revered Ashtavinayak shrines, located about 40 km from Morachi Chincholi. The temple is renowned for its spiritual significance and beautiful architecture."
  },
  {
    "WhyChooseheading": "Shirur Fort",
    "WhyChoosedescription": "A historical fort located around 20 km from Morachi Chincholi, offering panoramic views and a peek into the region’s Maratha history."
  },
  {
    "WhyChooseheading": "Vadgaon Dam - Nature’s Calm Retreat",
    "WhyChoosedescription": "A serene picnic spot near Shirur, Vadgaon Dam is surrounded by lush greenery and tranquil waters—ideal for family outings and relaxation."
  },
  {
    "WhyChooseheading": "Bhuleshwar Temple",
    "WhyChoosedescription": "Located about 50 km away, this 13th-century Shiva temple is known for intricate stone carvings and breathtaking hilltop views."
  },
  {
    "WhyChooseheading": "Ramling Mandir",
    "WhyChoosedescription": "A peaceful temple dedicated to Lord Shiva, situated approximately 30 km from Morachi Chincholi, offering a tranquil spiritual experience amidst nature."
  }
]













    }

const faqData = [
  {
    id: 'FAQ1',
    question: 'Why is Morachi Chincholi a top sightseeing spot near Pune?',
    answer: 'Located just 65 km from Pune, Morachi Chincholi is famous for its large peacock population, traditional rural lifestyle, and engaging agro-tourism experiences.',
  },
  {
    id: 'FAQ2',
    question: 'What can I see and do at Morachi Chincholi?',
    answer: 'You can watch peacocks in their natural habitat, enjoy bullock cart and tractor rides, explore butterfly gardens, walk through farms, and participate in rural games.',
  },
  {
    id: 'FAQ3',
    question: 'How far is Morachi Chincholi from Pune and how do I reach it?',
    answer: 'It’s approximately 65 km from Pune and takes 1.5 to 2 hours by car. The most convenient route is via Alandi or Chakan.',
  },
  {
    id: 'FAQ4',
    question: 'What makes the peacock sanctuary special?',
    answer: 'Morachi Chincholi is home to over 2,000 peacocks that roam freely around the village and farms—offering an exceptional natural spectacle, especially during monsoon.',
  },
  {
    id: 'FAQ5',
    question: 'Can I plan a one-day sightseeing trip here?',
    answer: 'Yes! Morachi Chincholi is perfect for a one-day trip with sightseeing, meals, nature walks, and photography opportunities—all in a serene rural setting.',
  },
  {
    id: 'FAQ6',
    question: 'Is there an entry fee to visit Morachi Chincholi?',
    answer: 'Entry to the village is free, but agro-tourism centers like Anand Krushi may charge nominal fees for guided tours, meals, and activities.',
  },
  {
    id: 'FAQ7',
    question: 'Are there other sightseeing places nearby?',
    answer: 'Yes, you can also visit Ranjangaon Mahaganpati Temple, Alandi Temple, and Jejuri—making it a full day of rural and spiritual exploration.',
  },
  {
    id: 'FAQ8',
    question: 'Is Morachi Chincholi suitable for photography lovers?',
    answer: 'Definitely! The open farms, flocks of peacocks, traditional bullock carts, and colorful rural scenes make it a paradise for photographers.',
  },
  {
    id: 'FAQ9',
    question: 'Is food available for tourists?',
    answer: 'Yes, most agro-tourism centers serve delicious home-style Maharashtrian meals made from fresh farm produce.',
  },
  {
    id: 'FAQ10',
    question: 'When is the best time to visit Morachi Chincholi?',
    answer: 'Visit during the monsoon and post-monsoon months (June to November) for lush greenery, active peacocks, and pleasant weather.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Prashant Naik, Pune',
    feedback: "Morachi Chincholi is a hidden gem near Pune. Seeing so many peacocks up close was a magical experience. The rural charm and local food made it even better.",
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Rucha Sathe, PCMC',
    feedback: "It was a perfect family outing—kids loved the bullock cart rides, and we enjoyed the peaceful vibe. It’s a refreshing alternative to the usual sightseeing spots around Pune.",
    rating: 5,
  },
];















    const carouselItems = testimonials.map(testimonial => (
        <div key={testimonial.name}>
            <blockquote>

                <p className='testi'>   <span className="quote">“</span>{testimonial.text}</p>
                <footer className=' user'>— {testimonial.name}</footer>
            </blockquote>
        </div>
    ));

    const carouselOptions = {
        loop: true,
        margin: 10,
        nav: true,
        items: 1
    };

    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9689125047",
            "+91 9623755047",
            "+91 9673132497",


        ],
        email: "thopatemala@gmail.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "One Day Picnic Spot Near Pune for Family",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "One Day Trip Near Pune",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Picnic Spot Near Pune ",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Picnic Destination Near Pune ",
        },
        {
            place: "/images/keyword/5.jpg",
            text: " Corporate Outing Resorts Near Pune",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "  Agri Tourism Near Pune",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Destination Wedding Near Pune",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Hurda Party Places Near Pune",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Water Park Near Pune",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "School Picnic Spots Near Pune for Students",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "One Day Adventure Resorts Near Pune",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Resort Near Pune ",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Forest Resorts Near Pune ",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Nature resorts near pune for weekend",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Mango Mahotsav in Pune",
        },
        {
            place: "/images/keyword/16.jpg",
            text: "Krushi Paryatan Kendra near Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Camping Places Near Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Activities Resort Near Pune",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Agro Tourism Near Mumbai for Family",
        },
        {
            place: "/images/keyword/20.jpg",
            text: "One Day Picnic Spot From Mumbai",
        },
        {
            place: "/images/keyword/21.jpg",
            text: "One Day Picnic Packages Near Mumbai",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "School Picnic Spots in Mumbai",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Resort Near Mumbai ",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Team Outing Places Near Mumbai",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Corporate Outing Near Mumbai",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Picnic Spot Near Nashik",
        },
        {
            place: "/images/keyword/27.jpg",
            text: "Farm House On Rent in Pune ",
        },
    ];


    const images = [
        { src: "/images/gallery/01.jpg", alt: "Image 1" },
        { src: "/images/gallery/02.jpg", alt: "Image 1" },
        { src: "/images/gallery/03.jpg", alt: "Image 1" },
        { src: "/images/gallery/04.jpg", alt: "Image 1" },
        { src: "/images/gallery/05.jpg", alt: "Image 1" },
        { src: "/images/gallery/06.jpg", alt: "Image 1" },
        { src: "/images/gallery/07.jpg", alt: "Image 1" },
        { src: "/images/gallery/08.jpg", alt: "Image 1" },
        { src: "/images/gallery/09.jpg", alt: "Image 1" },
        { src: "/images/gallery/010.jpg", alt: "Image 1" },
        { src: "/images/gallery/011.jpg", alt: "Image 1" },
        { src: "/images/gallery/012.jpg", alt: "Image 1" },

    ];

const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune Nearby Sightseeing Spot Morachi Chincholi",
  "image": "https://morachichincholi.in/assets/images/pune-sightseeing-morachi-chincholi.jpg",
  "description": "Explore top sightseeing spots near Morachi Chincholi, Pune including gardens, historical places, wildlife reserves, waterfalls, and eco-tourism trails. Ideal for family trips, cultural experiences, and photography lovers.",
  "brand": {
    "@type": "Brand",
    "name": "Anand Krushi Paryatan Kendra"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "2235"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "600",
    "availability": "https://schema.org/InStock",
    "url": "https://morachichincholi.in/pune-sightseeing-spot"
  }
};




    return (
        <div>
<Helmet>
  <title>Pune Nearby Sightseeing Spot Morachi Chincholi | Nature, Heritage & Family Tours</title>
  <meta 
    name="description" 
    content="Discover sightseeing places near Morachi Chincholi, Pune including nature trails, waterfalls, gardens, cultural sites, and eco-tourism hotspots. Perfect for families, photographers, and weekend travelers." 
  />
  <meta 
    name="keywords" 
    content="Sightseeing spots near Morachi Chincholi, Nature and garden tours, Historical sightseeing near Pune, Cultural attraction visits, Wildlife parks and reserves, Adventure sightseeing places, Scenic viewpoints and hills, Religious sightseeing spots, Family-friendly sightseeing tours, Local markets and fairs, Waterfall visits, Heritage tours, Eco-tourism sightseeing, Picnic-friendly sightseeing spots, Photography sightseeing locations" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
            <section className="breadcrumb-main pb-20 pt-14" style={{ backgroundImage: 'url(images/bg/bg1.jpg)' }}>
                <div className="section-shape section-shape1 top-inherit bottom-0" style={{ backgroundImage: 'url(images/shape8.png)' }}></div>
                <div className="breadcrumb-outer">
                    <div className="container">
                        <div className="breadcrumb-content text-center">
                            <h1 className="mb-3"> {cardData.keyword}</h1>

                        </div>
                    </div>
                </div>
                <div className="dot-overlay"></div>
            </section>





            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/15.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#609F31', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolor">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolor">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3 darkcolor'> Why Choose Anand Krushi Paryatan Kendra for {cardData.keyword + " Rates"}</h3>
                            {/* <BusRatesTable /> */}

                            <div id="why-choose-section"
                                className='px-2'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 darkcolor"> {item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">fAQS {cardData.keyword} For Anand Krushi Paryatan Kendra</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                {faqData.map((faq) => (
                                                    <FAQItemm key={faq.id} id={faq.id} question={faq.question} answer={faq.answer} />
                                                ))}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <div>

                                <div className="contact-box Borderr">
                                    <h3 className='darkcolor'>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Gallery</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image py-1"

                                            />
                                        </div>
                                    ))}
                                    {/* <Link to='/gallery' className=' border radius-5 bg-redd p-3 text-white rounded-5 '>
                    See Gallery
                  </Link> */}
                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #609F31',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#609F31' }}>
                                            <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2 text-white"></i>
                                            <div className=''>
                                                <a href="tel:+919689125047" className="d-block  text-white">+91 9689125047</a>
                                                <a href="tel:+919623755047" className="d-block  text-white">+91 9623755047</a>
                                                <a href="tel:+919673132497" className="d-block  text-white">+91 9673132497</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">

                                            <div className='rounded py-2' style={{ backgroundColor: '#609F31' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                                                <i className="bi bi-envelope fs-1 mb-2 text-white"></i>
                                                <a href="mailto:thopatemala@gmail.com" className=" text-white d-block">
                                                    thopatemala@gmail.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">

                                            <div className='rounded py-2' style={{ backgroundColor: '#609F31' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                                                <i className="bi bi-house-fill fs-1 mb-2 text-white"></i>
                                                <p className="whit text-white ">
                                                    <i> Anand Krushi Paryatan Kendra <br />
                                                        Dattatraya Anandrao Thopate, Topate Vasti, Chincholi Morachi, Tal. Shirur, Dist. Pune. Maharashtra - 412218

                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Punenearbysightseeingspot;